/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Modules_Add_PurchaseInputs */

const cs_clients_modules_add_purchase = /** @type {(inputs: Clients_Modules_Add_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat poptávku koupě`)
};

const en_clients_modules_add_purchase = /** @type {(inputs: Clients_Modules_Add_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add purchase demand`)
};

/**
* | output |
* | --- |
* | "Add purchase demand" |
*
* @param {Clients_Modules_Add_PurchaseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_modules_add_purchase = /** @type {((inputs?: Clients_Modules_Add_PurchaseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Modules_Add_PurchaseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_modules_add_purchase(inputs)
	return cs_clients_modules_add_purchase(inputs)
});